import * as THREE from "three";

export default class ThreeHelper {
  //https://stackoverflow.com/questions/27409074/converting-3d-position-to-2d-screen-position-r69
  static toScreenPosition(obj, camera, renderer) {
      var vector = new THREE.Vector3();

      var widthHalf = 0.5*renderer.context.canvas.width;
      var heightHalf = 0.5*renderer.context.canvas.height;

      obj.updateMatrixWorld();
      vector.setFromMatrixPosition(obj.matrixWorld);
      vector.project(camera);

      vector.x = ( vector.x * widthHalf ) + widthHalf;
      vector.y = - ( vector.y * heightHalf ) + heightHalf;

      return {
          x: vector.x,
          y: vector.y
      };

  };
}



// WEBPACK FOOTER //
// ./src/plugins/threehelper.js